import { Node } from 'prosemirror-model'
import { TextSelection } from 'prosemirror-state'

export const selectionFromRevision = (node: Node) => {
  let startPos: number | undefined
  let endPos: number | undefined
  node.descendants((node, pos) => {
    const relevantMarks = node.marks.filter((mark) => mark.type.name === 'ai_revision')
    if (relevantMarks.length > 0) {
      if (!startPos) startPos = pos
      endPos = pos + Math.max(node.textContent.length, 1)
    }

    return true
  })

  if (!startPos || !endPos) return null

  const $start = node.resolve(startPos)
  const $end = node.resolve(endPos)

  const isAtNodeEnd = $end.after(1) === $end.pos + $end.depth
  const isAtNodeStart = $start.before(1) === $start.pos - $start.depth

  if (isAtNodeEnd && isAtNodeStart) {
    return new TextSelection(node.resolve($start.before(1)), node.resolve($end.after(1)))
  }

  return new TextSelection($start, $end)
}
